import _ from 'lodash';

export default function getCookieDomain() {
  var cookieDomain = window.location.hostname;

  //account for subdomains
  _.forEach(['henrybuilt.com', 'spacetheory.com', 'primary-objects.com', 'herokuapp.com'], domain => {
    if (_.includes(cookieDomain, domain)) cookieDomain = `.${domain}`;
  });

  return cookieDomain;
};
